import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { LogoIcon } from "@/components/icons";
import { routes } from "@/routes/constants";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen bg-white">
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <div className="flex flex-col items-center text-center">
            <div className="mb-6">
              <LogoIcon className="h-16 w-auto" fill="#292A2F" />
            </div>

            <h1 className="text-2xl font-bold text-gray-900 mb-2">404 - Page introuvable</h1>

            <div className="w-full mt-4 p-4 bg-red-50 border border-red-200 rounded-md">
              <p className="text-sm font-semibold text-red-800 mb-2">Page introuvable</p>
              <p className="text-sm text-red-700 text-left break-words">
                La page que vous recherchez n'existe pas ou a été déplacée.
              </p>
            </div>

            <div className="mt-6 flex gap-3 w-full">
              <Link to={routes.root.path} className="w-full">
                <Button className="w-full" variant="default">
                  Retour à l'accueil
                </Button>
              </Link>
            </div>

            <p className="text-sm leading-6 text-gray-600 mt-4">
              Besoin d'aide ? Contactez le support si vous pensez qu'il s'agit d'une erreur.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
